import { lighten } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const COLORS = {
  primary: '#0A4DF2',
  primaryLight: lighten('#0A4DF2', 0.8),
  secondary: '#A51760',
  secondaryLight: lighten('#A51760', 0.8),
  action: '#18a90f',
  actionLight: lighten('#18a90f', 0.8),
  download: '#333333',
  downloadLight: lighten('#333333', 0.8),
  // Errors/Info
  red: '#F00',
  redLight: lighten('#F00', 0.8),
  amber: '#e84004',
  amberLight: lighten('#e84004', 0.8),
  // background
  darkgrey: '#333333',
  mediumgrey: '#666565',
  background: '#eaeff1',
  toolbarBackground: '#f6f5f4',
  white: '#FFF',
  facebookBlue: '#4267B2',
} as const;

export type ColorName = keyof typeof COLORS;
